import {
  ModeEditOutline,
  CheckCircleOutline,
  Inventory2Outlined,
} from "@mui/icons-material";

export const ScreenTypes = {
  COLLECTION: "collection",
  FOLDER: "folder",
  API: "api",
  NONE: "none",
};

export const ResourceTypes = {
  COLLECTION: "collection",
  FOLDER: "folder",
  ENTITY: "entity",
};

export const STATUS_TO_ICON = {
  draft: <ModeEditOutline fontSize="small" sx={{ color: "#fb662b" }} />,
  active: <CheckCircleOutline fontSize="small" color="success" />,
  archived: <Inventory2Outlined fontSize="small" sx={{ color: "gray" }} />,
};

export const BUILD_STATUS_TO_COLOR = {
  pass: "rgb(46, 125, 50)",
  fail: "rgb(211, 47, 47)",
};

export const TEST_SCENARIOS_PAGE_SIZE = 25;

export const VARIABLE_SETS_PAGE_SIZE = 25;

export const TEST_SUITES_PAGE_SIZE = 25;

export const TEST_PLANS_PAGE_SIZE = 25;

export const LOCAL_STORAGE_KEY_FOR_ENVIRONMENT = "primaryEnvironmentId";

export const FREE_EMAIL_DOMAINS = [
  // "gmail",
  "yahoo",
  "ymail",
  "rocketmail",
  "hotmail",
  "outlook",
  "live",
  "icloud",
  "me",
  "mac",
  "aol",
  "zoho",
  "proton",
  "protonmail",
  "gmx",
  "gmx",
  "mail",
  "yandex",
  "zoemail",
  "company",
  "killa",
  "email",
  "gamli",
  "qq",
  "vsmailpro",
  "yourflightdelas",
  "mytaemin",
  "gamil",
  "hi2",
  "abi",
  "simerm",
  "letterprotect",
  "fextemp",
  "oegmail",
  "hentai",
  "d-lusion",
  "jioso",
  "adizvr",
  "compey",
  "pm",
  "rowad-rme",
  "coderdir",
  "endibit",
  "inecco",
  "limecha",
  "fivemails",
  "oemails",
  "axcradio",
  "dxirl",
  "gemail",
  "wawa",
  "fuasha",
  "mechanicspedia",
  "grepruby",
  "bateriku",
  "vugitublo",
  "student.wuhsd",
  "lhory",
  "novertech",
  "sm",
  "forexzig",
  "yopmail",
  "compay",
  "linggongzhixuan",
  "modirosa",
  "katanajp",
  "nycstudents",
  "forexru",
  "gg",
  "xxx",
  "jer-system",
  "balincs",
  "786raja",
  "inbox",
  "atomicmail",
  "0tires",
  "compnay",
  "myyahoo",
  "sudo",
  "163",
  "164",
  "kloudis",
  "ikanteri",
  "gogpac",
  "zvvzuv",
  "necub",
  "foboxs",
  "mailpro",
  "sharklasers",
  "nicext",
  "efpaper",
  "ahvin",
  "cotasen",
  "bizmud",
  "mailtb",
  "colimarl",
  "baxidy",
  "owassops",
  "nqmo",
  "euleina",
  "jobzyy",
  "fivermail",
  "mudals",
  "modeapk",
  "emailwww",
  "novalyze",
  "mardiek",
  "neyop",
  "lespedia",
  "mogash",
  "evoxury",
  "litepax",
  "rapidletter",
  "ahanim",
  "patrniel",
  "emailwww",
  "mailslurp",
  "namestal",
  "jacksonday",
  "apicesaude",
  "tieal",
  "noidem",
  "mailinator",
  "cnic",
  "fxavaj",
  "mater",
  "axon",
  "disposalmail",
  "k12",
  "ihi",
  "badcode",
  "mask",
  "malldrops",
  "ibolinva",
  "carstudio",
  "temp-mail",
  "aiu3",
  "lespedia",
  "amblogistic",
  "mogash",
  "fcpsschools",
  "mater",
  "avankia",
  "fxavaj",
  "cnic",
  "noidem",
  "tieal",
  "apicesaude",
  "jacksonday",
  "besaies",
  "7-11",
  "arthermosets",
  "piaro",
  "cspaus",
  "johnsburg12",
  "generousial",
  "barakapower",
  "mirarmax",
  "sunyempire",
  "sarawak",
  "vexdren",
  "wvemedia",
  "fairfaxgroup",
  "dpwev",
  "student",
  "goe",
  "dayrep",
  "bangorschools",
  "wizmacau",
  "isg",
  "peepal",
  "tip",
  "ncien",
  "ostimteknik",
  "rediffmail",
  "qnap",
  "unik",
  "salexup",
  "dpwev",
  "juicebox-charging",
  "silsbeeisd",
  "boppotechnologies",
  "rajalakshmi",
  "soegy",
  "virgilio",
  "obirah",
  "axon",
  "vitalfew",
  "omnivoltaic",
  "banasthali",
  "programming",
  "miryas",
  "legaladvisoryserviceslimited",
  "ogr",
  "t-10",
  "gpcet",
  "best-hosting",
  "datoinf",
  "vlietschools",
  "apsk12",
  "cuvox",
  "bennett",
  "fixwap",
  "c2ken",
  "ryvelide",
  "alumnos",
  "daouse",
  "keevle",
  "swiftlist",
  "stu",
  "collector",
  "haotuwu",
  "lovleo",
  "g",
];

export const getMethodBadgeStyle = (method) => {
  const baseStyle = "px-3 py-1 rounded text-xs !font-medium";
  switch (method) {
    case "GET":
      return `${baseStyle} bg-green-100 text-green-800`;
    case "POST":
      return `${baseStyle} bg-amber-100 text-amber-800`;
    case "PUT":
      return `${baseStyle} bg-blue-100 text-blue-800`;
    case "DELETE":
      return `${baseStyle} bg-red-100 text-red-800`;
    case "PATCH":
      return `${baseStyle} bg-violet-100 text-violet-800`;
    case "HEAD":
      return `${baseStyle} bg-green-100 text-green-800`;
    case "OPTIONS":
      return `${baseStyle} bg-purple-100 text-purple-800`;
    default:
      return `${baseStyle} bg-gray-100 text-gray-800`;
  }
};

export const jsonViewCustomTheme = {
  "--w-rjv-font-family": "monospace",
  "--w-rjv-background-color": "var(--background-primary)",
  "--w-rjv-color": "var(--text-primary)",
  "--w-rjv-key-string": "#ff852a",
  "--w-rjv-info-color": "#ff852a",
  "--w-rjv-quotes-color": "#ff852a",
  "--w-rjv-type-string-color": "var(--text-secondary)",
  "--w-rjv-quotes-string-color": "var(--text-secondary)",
  "--w-rjv-type-int-color": "#22c55e",
  "--w-rjv-type-float-color": "#22c55e",
  "--w-rjv-type-bigint-color": "#22c55e",
  "--w-rjv-type-boolean-color": "#eab308",
  "--w-rjv-type-date-color": "#eab308",
  "--w-rjv-type-url-color": "#3b82f6",
  "--w-rjv-type-null-color": "var(--text-tertiary)",
  "--w-rjv-type-nan-color": "var(--text-tertiary)",
  "--w-rjv-type-undefined-color": "var(--text-tertiary)",
};

export const drawerWidth = 240;
export const COLLAPSED_WIDTH = 35;
